import api from "./api";

export const getArchivesPlant = async (plant: string) => {
    const response = await api.get(`archives/listAll?idPlant=${plant}`);
    return response.data;
};

export const getArchivesPlantOne = async (id: string) => {
    const response = await api.get(`archives/${id}`);
    return response.data;
};

export const deleteArchiveOne = async (id: string) => {
    const response = await api.delete(`archives/${id}`);
    return response.data;
};

export const postArchivePlantOne = async (file: any) => {
    const response = await api.post(`archives/`, file, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
};


export const getArchivesService = async (idService: string) => {
    const response = await api.get(`archives/listAll?idService=${idService ? idService : ""}`);
    return response.data;
};
